<!--
 * @Author: zl
 * @Date: 2021-12-09 09:07:38
 * @LastEditTime: 2023-06-02 11:33:31
 * @LastEditors: Please set LastEditors
 * @Description: 帮助中心内容维护
-->
<template>
	<div class="HelpCenter-layout">
		<split v-model="splitValue" v-if="!routeQuery">
			<div slot="left" class="left w-page-main">
				<div class="w-page-header border-bottom">
					<div class="left-text"><span>结构</span></div>
					<div class="btnGroups">
						<el-button type="primary" size="mini" class="btn-blue" @click="editTree" v-if="roleBtns.includes('edit_tree')"
							>编辑</el-button
						>
					</div>
				</div>
				<div class="w-page-container tree-box">
					<el-tree
						class="h100"
						:data="treeData"
						:props="treeProp"
						@node-click="treeClick"
						:expand-on-click-node="false"
						default-expand-all
						highlight-current
						:current-node-key="checkKey"
						ref="treeList"
						node-key="id"
					>
						<span class="custom-tree-node" slot-scope="{ node, data }">
							<div class="text-overflow">
								<i :class="data.pid === '0' ? 'el-icon-folder-opened' : 'el-icon-document'"></i>
								<el-tooltip effect="dark" :content="node.label" placement="top-start">
									<span>
										{{ node.label }}
									</span>
								</el-tooltip>
							</div>
						</span>
					</el-tree>
				</div>
			</div>
			<div slot="right" class="right w-page-main">
				<div class="w-page-header border-bottom">
					<div class="left-text">
						<span
							>目录：<span class="blue">{{ this.selectName }}</span></span
						>
					</div>
					<div class="btnGroups">
						<el-button type="primary" size="mini" class="btn-blue" @click="viewDemo">预览</el-button>
					</div>
				</div>
				<div class="w-page-container" style="padding:0">
					<div class="w-page-main">
						<div class="w-page-header">
							<div class="left-text">合计：{{ tableObj.total }}条</div>
							<div class="btnGroups">
								<el-input v-model="searchTitle" placeholder="请输入标题名称" size="small" class="w300">
									<template slot="append">
										<el-button type="primary" class="btn-blue" size="small" @click="searchTable">查询</el-button>
									</template>
								</el-input>
								<el-button
									type="primary"
									size="small"
									class="btn-blue ml10"
									v-if="roleBtns.includes('add_content')"
									@click="doClick('', 'add')"
									>添加内容</el-button
								>
								<el-button
									type="primary"
									class="btn-blue"
									:class="{ ml10: !roleBtns.includes('add_content') }"
									size="small"
									@click="resetTable"
									>刷新</el-button
								>
							</div>
						</div>
						<div class="w-page-container">
							<div class="w-table-layout w-table-page">
								<div class="w-table-content">
									<vxe-table
										align="center"
										border
										:data="tableObj.data"
										highlight-current-row
										highlight-hover-row
										height="100%"
										key="1"
										:loading="tableObj.loading"
										size="small"
										show-overflow="tooltip"
										show-header-overflow="tooltip"
									>
										<vxe-table-column type="seq" title="序号" width="70"></vxe-table-column>
										<vxe-table-column
											field="title"
											title="内容标题"
											header-align="center"
											align="left"
											min-width="300"
										></vxe-table-column>
										<vxe-table-column field="catalogue" title="目录" min-width="120"></vxe-table-column>
										<vxe-table-column field="updateUserName" title="编辑人" min-width="120"></vxe-table-column>
										<vxe-table-column field="releaseDate" title="发布时间" width="180"></vxe-table-column>
										<vxe-table-column field="status" title="状态" width="140">
											<template #default="{ row }">
												<span v-if="row.status === 0" class="orange">未发布</span>
												<span v-if="row.status === 1" class="green">已发布</span>
											</template>
										</vxe-table-column>
										<vxe-table-column title="操作" width="180">
											<template #default="{ row }">
												<el-button
													type="success"
													class="table-btn"
													round
													plain
													icon="el-icon-edit"
													v-if="roleBtns.includes('view_content')"
													@click="doClick(row, 'edit')"
													>编辑
												</el-button>
												<!-- 帮助中心已发布状态下可以编辑 -->
												<!-- <el-button type="primary"
														   class="table-btn"
														   round
														   plain
														   icon="el-icon-view"
														   v-if="roleBtns.includes('add_content') && row.status === 1"
														   @click="doClick(row, 'view')">查看
												</el-button>
												<el-button type="success"
														   class="table-btn"
														   round
														   plain
														   icon="el-icon-edit"
														   v-if="roleBtns.includes('view_content') && row.status === 0"
														   @click="doClick(row, 'edit')">编辑
												</el-button> -->
												<el-button
													type="danger"
													class="table-btn"
													round
													plain
													icon="el-icon-delete"
													:disabled="row.status === 1"
													v-if="roleBtns.includes('delete_content')"
													@click="doClick(row, 'delete')"
													>删除
												</el-button>
											</template>
										</vxe-table-column>
									</vxe-table>
								</div>
								<div class="w-table-footer">
									<el-pagination
										@size-change="handleCurrentChange($event, 'pageSize')"
										@current-change="handleCurrentChange($event, 'currentPage')"
										:current-page="tableObj.currentPage"
										:page-sizes="tableObj.pageList"
										:page-size="tableObj.pageSize"
										layout="total, sizes, prev, pager, next, jumper"
										:total="tableObj.total"
									>
									</el-pagination>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</split>

		<AddContent v-else :selectName="selectName" :rowData="rowData"></AddContent>

		<!-- 编辑结构 -->
		<el-dialog
			title="帮助文档目录结构"
			:visible.sync="dialogObj.show"
			width="1000px"
			:close-on-click-modal="false"
			center
			:before-close="diaLogClose"
		>
			<el-tree
				v-if="dialogObj.show"
				:data="addTreeData"
				node-key="treeId"
				ref="editTree"
				class="custom-tree"
				default-expand-all
				highlight-current
				:expand-on-click-node="false"
			>
				<div class="custom-row" slot-scope="{ node, data }">
					<span class="sname-width">
						<el-input type="text" size="small" placeholder="请输入节点名称" v-model="data.sname" maxlength="20" show-word-limit>
						</el-input>
					</span>
					<span class="tool-width">
						<el-dropdown placement="bottom" @command="handleClick($event, data)">
							<i class="el-icon-plus"></i>
							<el-dropdown-menu slot="dropdown">
								<el-dropdown-item command="child" v-if="data.level < 3">子级节点</el-dropdown-item>
								<el-dropdown-item command="same">平级节点</el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown>
						<i class="el-icon-delete ml10" @click="removeNode(data)"></i>
					</span>
				</div>
			</el-tree>
			<div slot="footer">
				<el-button class="btn" @click="btnHandler('cancel')">取 消</el-button>
				<el-button type="primary" class="btn btn-blue" @click="btnHandler('submit')">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
import split from '@/components/split/split'
import AddContent from '@/views/operation-management/rules-management/add-content'
import * as API from 'api/modules/rulesManagement'
import { mapState } from 'vuex'
import { Snowflake } from 'node-snowflake'
export default {
	name: 'HelpCenter',
	components: { split, AddContent },
	props: {},
	data() {
		return {
			splitValue: 0.2,
			treeData: [], //结构数据
			addTreeData: [], //添加结构数据
			treeProp: {
				label: 'sname'
			}, //结构配置
			searchTitle: '', //搜索标题
			tableObj: {
				pageSize: 10,
				currentPage: 1,
				total: 0,
				loading: false,
				pageList: [10, 20, 50, 100], // 显示条数数组
				data: []
			},
			dialogObj: {
				show: false,
				data: [],
				prop: {
					label: 'sname'
				}
			},
			selectObj: {},
			selectName: '',
			rowData: {},
			checkKey: '',
			selectArr: []
		}
	},
	created() {
		// 获取左侧结构
		this.getTreeData(1)
		if (this.$getSessionItem('checkKey')) {
			this.checkKey = JSON.parse(this.$getSessionItem('checkKey'))

			// 移除 避免污染
			this.$removeSessionItem('checkKey')
		}
		if (this.$getSessionItem('selectName')) {
			this.selectName = JSON.parse(this.$getSessionItem('selectName'))

			// 移除 避免污染
			this.$removeSessionItem('selectName')
		}
	},
	methods: {
		// 获取左侧结构
		getTreeData(first) {
			API.selHelpCatalog({}).then((res) => {
				this.treeData = res.data
				this.addTreeData = this.$utils.clone(res.data, true)
				if (first && this.checkKey != '') {
					let list = this.$utils.findTree(this.addTreeData, (x) => x.id == this.checkKey)
					this.selectObj = list.item
					this.treeClick(this.selectObj)
					return
				}
				this.checkKey = this.treeData[0].children[0].id
				console.log(this.checkKey)
				this.treeClick(this.treeData[0].children[0])
				this.$nextTick(() => {
					this.$refs.treeList.setCurrentKey(this.checkKey)
				})
			})
		},

		// 左侧结构树点击事件
		treeClick(data) {
			if (data.pid == '0') {
				return
			}
			let checkKey = data.id
			this.$setSessionItem('checkKey', JSON.stringify(checkKey))
			this.selectObj = this.$utils.clone(data, true)
			let arr = [data.sname]
			this.dealName(data.pid, arr)
			this.selectName = this.selectArr.join(' > ')
			this.getContentData()
		},

		dealName(pid, arr) {
			if (pid == '0') {
				this.selectArr = arr
				return
			}
			let list = this.$utils.findTree(this.treeData, (x) => x.id == pid)
			if (list) {
				arr.unshift(list.item.sname)
				this.dealName(list.item.pid, arr)
			}
		},
		// 编辑事件
		editTree() {
			this.dialogObj.show = true
			if (this.addTreeData.length == 0) {
				this.addTreeData.push({
					sname: '',
					pid: '0',
					treeId: '10086',
					children: []
				})
			}
		},

		// 预览
		viewDemo() {
			let type = process.env.NODE_ENV
			console.log(type)
			switch (type) {
				case 'development':
					window.open('http://172.16.0.20:8080/#/help/index')
					break
				case 'test':
					window.open('https://c.nenggongshe.com/ngs_share_login/#/help/index')
					break
				case 'pre':
					window.open('https://b.nenggongshe.com/ngs_share_login/#/help/index')
					break
				case 'prod':
					window.open('https://www.52ngs.com/ngs_share_login/#/help/index')
					break
			}
		},

		// 搜索
		searchTable() {
			this.tableObj.currentPage = 1
			this.getContentData()
		},

		// 刷新
		resetTable() {
			if (!this.selectObj.id) {
				return
			}
			this.searchTitle = ''
			this.searchTable()
		},

		// 获取当前结构下的内容
		getContentData() {
			API.selHelpDetailList({
				id: this.selectObj.id,
				pid: this.selectObj.pid,
				title: this.searchTitle,
				size: this.tableObj.pageSize,
				current: this.tableObj.currentPage
			}).then((res) => {
				this.tableObj.data = res.data.records
				this.tableObj.total = parseInt(res.data.total)
			})
		},

		// 点击事件
		async doClick(data, type) {
			let resData = {}
			switch (type) {
				case 'add':
					if (!this.selectObj.id) {
						this.$message.warning('请先选择左侧节点')
						return
					}
					break
				case 'view':
				case 'edit':
					resData = await this.getDetail(data.id).catch((err) => {})
					resData = {...data, ...resData}
					this.rowData = this.$utils.clone(resData, true)
					break
				case 'delete':
					this.$confirm('此操作将删除该内容, 是否继续?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					})
						.then(() => {
							API.delHelpDetail({
								id: data.id
							}).then((res) => {
								this.$message.success(res.msg)
								this.getContentData()
							})
						})
						.catch(() => {
							this.$message.info('已取消删除')
						})
					break
			}
			if (type != 'delete') {
				// 存值
				let checkKey = this.selectObj.id
				this.$setSessionItem('checkKey', JSON.stringify(checkKey))
				this.$setSessionItem('selectName', JSON.stringify(this.selectName))
				this.$router.push({
					path: '/helpCenter',
					query: {
						type,
						id: this.selectObj.id
					}
				})
			}
		},
		// 获取详情
		getDetail(id) {
			return new Promise((resolve, reject) => {
				API.getHelpDetail({ id })
					.then(res => {
						resolve({ content: res.data })
					})
					.catch(err => {
						reject(err)
					})
			})
		},

		// 点击事件
		handleClick(type, data) {
			let obj
			obj = this.$utils.findTree(this.addTreeData, (item) => item.id === data.pid)
			// return
			// obj = this.$utils.findTree(
			//   this.addTreeData,
			//   (item) => item.treeId === data.treeId
			// );
			let add_node = {
				sname: '',
				pid: '',
				level: '',
				id: Snowflake.nextId(),
				children: [],
				isAdd: true
			}
			console.log(obj)
			if (type == 'same') {
				add_node.pid = data.pid
				add_node.level = data.level
				if (data.pid == '0') {
					this.addTreeData.push(add_node)
					return
				}
				add_node.level = data.level
				obj.item.children.push(add_node)
			}
			if (type == 'child') {
				add_node.level = data.level + 1
				add_node.pid = data.id
				data.children.push(add_node)
			}
			// 设置选中
			setTimeout(() => {
				this.$refs.editTree.setCurrentKey(add_node.treeId)
			}, 300)
		},

		// 删除节点
		removeNode(data) {
			let obj = this.$utils.findTree(this.addTreeData, (item) => item.id === data.id)
			if (data.isAdd) {
				obj.items.splice(obj.index, 1)
				return
			}
			this.$confirm('此操作将删除该节点, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(() => {
					API.delHelpCatalog({
						id: data.id
					}).then((res) => {
						if (res.operationCode === 0) {
							this.$message.error(res.msg)
							return
						}
						this.$message.success(res.msg)
						obj.items.splice(obj.index, 1)
					})
				})
				.catch(() => {
					this.$message.info('已取消删除')
				})
		},

		// 弹窗按钮事件
		btnHandler(type) {
			if (type == 'cancel') {
				this.dialogObj.show = false
				this.getTreeData()
				return
			}
			let params = this.$utils.clone(this.addTreeData, true)
			let requireSname = this.$utils.filterTree(params, (x) => x.sname === '')
			if (requireSname.length > 0) {
				this.$message.warning('请完善结构名称!')
				return
			}
			API.saveOrEditHelpCatalog({
				allList: params
			}).then((res) => {
				this.$message.success(res.msg)
				this.diaLogClose()
			})
		},

		// 结构弹窗关闭前回调
		diaLogClose() {
			this.getTreeData()
			this.dialogObj.show = false
		},

		// 分页处理
		handleCurrentChange(data, type) {
			this.tableObj[type] = data
			this.getContentData()
		}
	},
	computed: {
		...mapState('menu', {
			roleBtns: (state) => state.roleBtns
		}),

		routeQuery() {
			return this.$route.query.type
		}
	}
}
</script>
<style lang="less" scoped>
.HelpCenter-layout {
	height: 100%;
	background-color: #fff;
	.border-bottom {
		border-bottom: 1px dashed #aaa;
	}
	.tree-box {
		padding: 20px;
	}
	.blue {
		color: #2671cc;
	}
	.custom-tree-node {
		font-size: 14px;
		padding-right: 8px;
		width: 100%;
	}
	.status-circle {
		content: '';
		display: inline-block;
		width: 12px;
		height: 12px;
		line-height: 12px;
		margin-right: 10px;
		vertical-align: middle;
		border-radius: 50%;
	}
	.green::before {
		.status-circle();
		background-color: #72aa2c;
		box-shadow: 0px 0px 4px 0px #72aa2c;
	}
	.orange::before {
		.status-circle();
		background-color: orange;
		box-shadow: 0px 0px 4px 0px orange;
	}
}
</style>

<style lang="less">
.custom-tree {
	.el-tree-node__content {
		height: 40px;
		line-height: 40px;
	}

	.el-tree-node__content:hover {
		background-color: #e6f3ff;
	}

	.el-tree-node.is-current > .el-tree-node__content {
		background-color: #e6f3ff !important;
	}
	.w300 {
		/deep/ .el-input__inner {
			width: 300px !important;
		}
	}
}
.custom-row {
	display: flex;
	width: 100%;
	color: #202020;

	.sname-width {
		min-width: 350px;
		flex: 1;
		padding: 0 10px;
	}

	.tool-width {
		width: 80px;
		text-align: center;
		padding: 0 10px;
	}
}
</style>
